var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-authentication-modal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("system.user_authentication"),
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.initData,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c(
            "div",
            {
              staticStyle: {
                width: "420px",
                "font-style": "normal",
                "font-weight": "400",
                "font-size": "18px",
                "line-height": "22px",
                color: "#4B5567",
              },
            },
            [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "tips.MFA_verification_code_authenticate_user_access"
                    )
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { "margin-top": "30px" },
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "code" } },
                [
                  _c("el-input", {
                    staticClass: "search-frame",
                    attrs: {
                      placeholder: "Enter your MFA verification code",
                      autocomplete: "off",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "code", $$v)
                      },
                      expression: "form.code",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.listLoading },
                  on: { click: _vm.onClickSubmitBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }